const FOOD = {
    breakfast: require("./breakfast.png"),
    dinner: require("./dinner.png"),
    lunch: require("./lunch.png"),
    snack: require("./snack.png"),
  };
  
  export default FOOD;
  